export const reviewPeriodElapsed = ({ context }) => !!context.reviewPeriodElapsed;
export const targetsMet = ({ context }) => !!context.targetsMet;
export const targetsNotMet = ({ context }) => !!context.targetsNotMet;
//# sourceMappingURL=pip.js.map